import { AlertCircle } from 'lucide-react';
import React from 'react';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';

interface ErrorMessageProps {
  errorMessage?: string | null;
  errorList?: string[] | null;
}

export const ErrorMessage: React.FC<ErrorMessageProps> = ({
  errorMessage,
  errorList = [],
}) => {
  return (
    <>
      {/* Error Message */}
      {errorMessage && (
        <Alert variant="destructive">
          <AlertCircle className="h-4 w-4" />
          <AlertTitle>Fehler</AlertTitle>
          <AlertDescription>
            {errorMessage}
            {errorList.map((err) => (
              <ul className="list-disc list-inside space-y-1 mt-2">
                <li>{err}</li>
              </ul>
            ))}
          </AlertDescription>
        </Alert>
      )}
    </>
  );
};
